import { FC } from 'react';
import styles from './index.module.less';
import FourNoSumPredictSale from '@/common/components/business/AreaScoreWithoutSum/FourNoSumPredictSale';
import { Col, Row } from 'antd';
import ScoreCard from '../ScoreCard';
import ScoreExplaimIcon from './ScoreExplaimIcon';

/**
 * @Description 四维无总分-商圈详情
 */
const FourNoSumCon:FC<{
  overViewData: any;
  predictSale: any;
  cardView: any;
  isPdf?:boolean;
  modelConfigId?:any
  shareParams?:any
  isSemirModel?: boolean;
  showScoreDescriptionFlag?: any;
  scoreDescription?: any;
}> = ({
  overViewData,
  predictSale,
  cardView,
  isPdf = false,
  modelConfigId,
  shareParams,
  isSemirModel = false,
  showScoreDescriptionFlag,
  scoreDescription,
}) => {
  return (
    <div className={styles.fourNoSumCon}>
      <div className={styles.title}>
        四维评分
        {!isPdf && !isSemirModel && showScoreDescriptionFlag !== 3 && <ScoreExplaimIcon
          data={overViewData}
          predictSale={predictSale}
          className={styles.titleIcon}
          shareParams={shareParams}
          modelConfigId={modelConfigId}
          showScoreDescriptionFlag={showScoreDescriptionFlag}
          scoreDescription={scoreDescription}
        />}
      </div>
      {predictSale ? <FourNoSumPredictSale data={overViewData} className={styles.predictSale}/> : <></>}
      <div className={styles.cardView}>
        <Row gutter={[24, 14]}>
          {cardView.length ? cardView.map((item, index: number) => (
            <Col span={12} key={item?.name}>
              <ScoreCard
                title={item?.name}
                score={item?.score}
                totalScore={item?.percent}
                // describe={item?.msg}
                lineColor='#5B9FFF'
                lineBgColor='#FFFFFF'
                // 森马模型的维度中有四个字/五个字的区别， 为了展示美观
                hasBlank={isSemirModel && (index === 1 || index === 3)}
                isSemirModel={isSemirModel}
              />
            </Col>
          )) : <></>}
        </Row>
      </div>
    </div>
  );
};

export default FourNoSumCon;
